import React, { useEffect, useRef, useState } from "react";
import { login, post } from "../modules/server";
import { useNavigate, useSearchParams } from "react-router-dom";
import { logAndNotifyError } from "../modules/logger";
import { UserInfo } from "../types/user-info";
import PubSub from "pubsub-js";
import { useForm } from "react-hook-form";
import TextEditor from "../components/Global/Editors/TextEditor";
import { Card } from "react-bootstrap";
import NumberEditor from "../components/Global/Editors/NumberEditor";
import { checkOrganisationNumber } from "../modules/common";
import CheckboxEditor from "../components/Global/Editors/CheckboxEditor";
import { Button } from "devextreme-react";
import Abonnemang from "../components/Abonnemang";

// interface IProps {
//   returnTo: string;
//   //onLoggedIn : (info:UserInfo) => void;
// }

const Register = () => {
  //const [userInfo, setUserInfo] = useState({ userId: null as null | string, code: null as null | string });
  const [searchParams] = useSearchParams();
  const [registrationSucceeded, setRegistrationSucceeded] = useState(false);
  const submittingRef = useRef(false); // re-entrancy guard
  // const navigate = useNavigate();

  const formHook = useForm({
    defaultValues: {} as any,
  });

  const {
    handleSubmit,
    formState,
    formState: { errors },
  } = formHook;

  const hasErrors = Object.keys(errors).length > 0;

  const prefersPDFInvoice = formHook.watch("prefersPDFInvoice");
  const hasAcceptedConditions = formHook.watch("hasAcceptedConditions");

  const code = searchParams.get("code");

  const onSubmit = async (data: any) => {
    if (submittingRef.current) return; // guard against double submits
    submittingRef.current = true;
    try {
      const regResult = await post("RegisterNewClient", data);
      if (regResult.success) {
        setRegistrationSucceeded(true);
      } else {
        if (regResult.message) logAndNotifyError("Registreringen misslyckades : " + regResult.message);
        else logAndNotifyError("Registreringen misslyckades !");
      }
    } catch (ex) {
      logAndNotifyError("Registreringen misslyckades pga fel: " + ex);
    } finally {
      submittingRef.current = false; //Release guard
    }
  };

  const isBusy = formState.isSubmitting || submittingRef.current;

  if (!registrationSucceeded) {
    return (
      <>
        <h2>Välkommen till QWTOOL</h2>
        <Card>
          <Card.Header style={{ color: "black" }}>Registrera ditt företag</Card.Header>
          <Card.Body>
            Fyll i nedanstående formulär för att påbörja ett abonemang av QWTOOL. Efter komplett ifyllt formulär skickas ett mail till din email-adress. Efter att ha bekräftat din emailadress, kommer
            du att kunna ange ett lösenord och börja använda systemet. Du accepterar därmed villkoren för användning av QWTOOL.
          </Card.Body>
        </Card>

        {code || true /* Villkor för att kunna registrera? Kod från externt system */ ? (
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Card className="mt-4">
                <Card.Header>Företagsuppgifter</Card.Header>
                <Card.Body>
                  <div className="row overflow-hidden gy-0  align-items-end">
                    <div className="col-lg-6">
                      <TextEditor
                        label="Företagets namn"
                        fieldName="companyName"
                        formHook={formHook}
                        options={{
                          required: "Du måste ange företagets namn!",
                          minLength: 2,
                        }}
                      />
                    </div>
                    <div className="col-lg-6">
                      <TextEditor
                        label="Organisationsnummer"
                        fieldName="organisationNumber"
                        formHook={formHook}
                        options={{
                          required: "Du måste ange företagets organisationsnummer!",

                          validate: {
                            checkOrganisationNumber: (val: string) => {
                              return checkOrganisationNumber(val) ? undefined : "Ogiltigt organisations-nummer!";
                            },
                            // checkLength: (val: string) => (val?.length < 10 ? "Organisations-nummer måste vara 10 siffror!" : undefined),
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="row overflow-hidden gy-0  align-items-end">
                    <div className="col-lg-6">
                      <TextEditor
                        label="E-post adress (Hit skickas inloggningsuppgifter & orderbekräftelse)"
                        fieldName="email"
                        formHook={formHook}
                        options={{
                          required: "E-post måste anges!",
                          //pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$",
                        }}
                      />
                    </div>
                    <div className="col-lg-6">
                      <TextEditor
                        label="Mobiltelefon (beställare)"
                        fieldName="phoneNumber"
                        formHook={formHook}
                        options={{
                          required: "Telefonnummer måste anges!",
                          //pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$",
                        }}
                      />
                    </div>
                  </div>

                  <div className="row overflow-hidden gy-0  align-items-end">
                    <div className="col-lg-12">
                      <TextEditor
                        label="Postadress"
                        fieldName="street"
                        formHook={formHook}
                        options={{
                          required: "Postadress måste anges!",
                          //pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$",
                        }}
                      />
                    </div>
                  </div>
                  <div className="row overflow-hidden gy-0  align-items-end">
                    <div className="col-lg-6">
                      <TextEditor
                        label="Postnummer"
                        fieldName="postalCode"
                        formHook={formHook}
                        options={{
                          required: "Postnummer måste anges!",
                          //pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$",
                        }}
                      />
                    </div>
                    <div className="col-lg-6">
                      <TextEditor
                        label="Postort"
                        fieldName="city"
                        formHook={formHook}
                        options={{
                          required: "Postort måste anges!",
                          //pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$",
                        }}
                      />
                    </div>
                  </div>

                  <div className="row overflow-hidden gy-0  align-items-end">
                    <div className="col-lg-6">
                      <TextEditor
                        label="Orderreferens (Fakturamärke)"
                        fieldName="orderReference"
                        formHook={formHook}
                        options={{
                          required: "Orderreferens måste anges!",
                          //pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$",
                        }}
                      />
                    </div>
                    <div className="col-lg-6">
                      <TextEditor
                        label="Fakturareferens (Namn beställare)"
                        fieldName="invoiceReference"
                        formHook={formHook}
                        options={{
                          required: "Fakturareferens måste anges!",
                          //pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$",
                        }}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 pt-3">
                      <CheckboxEditor
                        label="Jag vill ha pdf-faktura"
                        fieldName="prefersPDFInvoice"
                        formHook={formHook}
                        options={{
                          onChange: () => {
                            const currentValues = formHook.getValues();

                            const prefersEDIInvoice = currentValues.prefersEDIInvoice;
                            const prefersPDFInvoice = currentValues.prefersPDFInvoice;
                            if (prefersEDIInvoice && prefersPDFInvoice) formHook.setValue("prefersEDIInvoice", false);

                            if (prefersPDFInvoice && currentValues.email) formHook.setValue("emailInvoice", currentValues.email);
                            if (!prefersPDFInvoice || !currentValues.email) formHook.setValue("emailInvoice", undefined);
                          },
                        }}
                      />
                    </div>
                    {/* {villHaPdfFaktura && ( */}
                    <div className="col-lg-6">
                      <TextEditor
                        label="E-post för pdf-faktura"
                        fieldName="emailInvoice"
                        formHook={formHook}
                        options={{
                          required: prefersPDFInvoice ? "E-post för pdf-faktura måste anges!" : undefined,
                          //pattern: "^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$",
                        }}
                        isDisabled={!prefersPDFInvoice}
                      />
                    </div>
                    {/* )} */}
                  </div>
                  <div className="row overflow-hidden gy-0  align-items-end">
                    <div className="col-lg-6   pt-3">
                      <CheckboxEditor
                        label="Jag vill ha E-faktura(EDI)"
                        fieldName="prefersEDIInvoice"
                        formHook={formHook}
                        options={{
                          onChange: () => {
                            const currentValues = formHook.getValues();
                            const prefersEDIInvoice = currentValues.prefersEDIInvoice;
                            const prefersPDFInvoice = currentValues.prefersPDFInvoice;
                            if (prefersEDIInvoice && prefersPDFInvoice) formHook.setValue("prefersPDFInvoice", false);
                            if (prefersEDIInvoice && currentValues.emailFaktura) formHook.setValue("emailInvoice", undefined);
                          },
                        }}
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
              <hr />
              <div className="row overflow-hidden gy-0   mt-4 ">
                <div className="col-lg-6 mb-4">
                  <Card>
                    <Card.Header>Abonnemang</Card.Header>
                    <Card.Body>
                      <Abonnemang formHook={formHook} />
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-lg-6 ps-lg-5 ">
                  <Card>
                    <Card.Header>Godkänn</Card.Header>
                    <Card.Body>
                      <div className="row mt-3">
                        <div className="col-xl-6">
                          <div className="row ps-2 pe-2">
                            <button
                              type="button"
                              className="btn btn-secondary "
                              onClick={() => {
                                PubSub.publish("ShowHelp", "allmännaVillkor");
                              }}
                            >
                              Visa allmänna villkor
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-lg-12 ps-2">
                          <CheckboxEditor
                            label="Jag har läst och godkänner de allmänna villkoren"
                            fieldName="hasAcceptedConditions"
                            formHook={formHook}
                            options={{
                              required: "Du måste godkänna de allmänna villkoren!",
                            }}
                            isDisabled={isBusy}
                          />
                        </div>
                      </div>
                      <div className="row mt-5">
                        <div className="col-xl-6 ">
                          <div className="row ps-2 pe-2">
                            <button type="submit" className={hasAcceptedConditions && !hasErrors ? "btn btn-success" : "btn btn-primary"} disabled={isBusy} aria-busy={isBusy}>
                              {isBusy ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  <span>Abonemang registreras...</span>
                                </>
                              ) : (
                                <>
                                  <span>Bekräfta angivna uppgifter</span>
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              {/* <hr /> */}

              {/* <div className="row overflow-hidden gy-0  align-items-end">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      PubSub.publish("ShowHelp", "allmännaVillkor");
                    }}
                  >
                    Visa allmänna villkor
                  </button>
                </div>

                <div className="col-lg-6">
                  <CheckboxEditor
                    label="Jag har läst och godkänner de allmänna villkoren"
                    fieldName="hasAcceptedConditions"
                    formHook={formHook}
                    options={{
                      required: "Du måste godkänna de allmänna villkoren!",
                      onChange: () => {},
                    }}
                  />
                </div>
              </div>

              <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-3">
                <div style={{ paddingRight: 12, paddingLeft: 4 }}>
                  <button type="submit" className="btn btn-primary ms-2">
                    Bekräfta angivna uppgifter
                  </button>
                </div>
              </div> */}
            </form>
          </div>
        ) : (
          <>Denna funktion är inte tillgänglig</>
        )}
      </>
    );
  } else {
    return (
      <>
        {/* <h2>Du har registrerats som kund hos QWTOOL!</h2> */}
        <Card>
          <Card.Header style={{ color: "black" }}>Registreringen lyckades!</Card.Header>
          <Card.Body>Kontrollera din mail och följ aktiveringslänken (Kontrollera skräpkorgen om du inte hittar mailet).</Card.Body>
        </Card>
      </>
    );
  }
};

export default Register;
